// src/data/studentsData.js

export const stages = [
  "الصف الأول الإعدادي",
  "الصف الثاني الإعدادي",
  "الصف الثالث الإعدادي",
  "الصف الأول الثانوي",
  "الصف الثاني الثانوي",
  "الصف الثالث الثانوي"
];

export const groups = [
  { id: 1, stage: "الصف الأول الإعدادي", name: "مجموعة أ", time: "السبت والثلاثاء 4:00 عصراً" },
  { id: 2, stage: "الصف الأول الإعدادي", name: "مجموعة ب", time: "الأحد والأربعاء 5:00 مساءً" },
  { id: 3, stage: "الصف الثالث الثانوي", name: "مجموعة النخبة", time: "الجمعة 8:00 صباحاً" }
];

export const students = [
  {
    id: "STU-001",
    name: "أحمد محمود",
    stage: "الصف الأول الإعدادي",
    groupId: 1,
    parentPhone: "01012345678",
    status: "نشط"
  },
  {
    id: "STU-002",
    name: "كريم حسن",
    stage: "الصف الثالث الثانوي",
    groupId: 3,
    parentPhone: "01112345678",
    status: "نشط"
  }
];